// src/components/ProtectedRoute.js
import React from 'react';
import { Navigate, Outlet } from 'react-router-dom';
import { useAuth } from './AuthContext';

const ProtectedRoute = () => {
    const { isAuthenticated, isAdmin } = useAuth();

    return (
        isAuthenticated && isAdmin ? <Outlet /> : <Navigate to="/Admin/login" />
    );
};

export default ProtectedRoute;
